const BaseView = require('./view');

module.exports = BaseView.extend({
    containerClasses: Odigeo.AB.isCssVariationMobile ? 'prisma-responsive-space-horizontal' : 'odf-space-outer-bottom-m odf-box odf-row',
    paxRowClasses: Odigeo.AB.isCssVariationMobile ?
        'odf-space-inner-top-m odf-space-inner-bottom-m' : 'odf-space-inner-m',
});
